var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-tab"},[(_vm.loading)?_c('div',{staticClass:"video-tab--loading d-flex justify-content-center align-items-center"},[_c('b-icon-camera-video-fill')],1):_c('div',{staticClass:"video-tab--content"})])}
var staticRenderFns = []

export { render, staticRenderFns }